import { render } from "./KRProgressActivity.vue?vue&type=template&id=873ac584"
import script from "./KRProgressActivity.vue?vue&type=script&lang=js"
export * from "./KRProgressActivity.vue?vue&type=script&lang=js"
script.render = render

export default script